<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Demandas de Exames - Empresa Contratante"
  description="Gerencie as demandas de exames e terapias da sua empresa">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <ng-container>
    <div style="max-width: 1024px; text-align: left; width: 100%">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let resourceDemand of resourceDemandList; trackBy: trackById; let i = index"
          (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="mat-panel-title-custom">
                {{ resourceDemand.id }} -
                <span class="field-value">
                  {{ getResourcesDescription(resourceDemand.resource) }}
                </span>
              </div>
              <div class="observationText">
                <div>
                  @if(resourceDemand.publicationDate) {Data da Publicação:
                  {{ resourceDemand.publicationDate | date : "dd/MM/yyyy " }}

                  @if(resourceDemand.expirationPublicationDate) { - Valido até:
                  {{
                  resourceDemand.expirationPublicationDate
                  | date : "dd/MM/yyyy "
                  }}} } @else {Não Publicado }
                </div>
                <div style="flex: 1 0 50px; place-self: self-end">
                  {{ resourceDemand.status! | enumDescription }}
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-panel-description style="flex-wrap: wrap">
            <!-- oferta de exames e terapias demandados agrupados por categorias -->
            <div class="resources-container">
              <ng-container *ngIf="getResourceGroups(resourceDemand.resource) as resourceGroups">
                <!-- Seção de Exames -->
                <ng-container *ngIf="resourceGroups.exames.length > 0">
                  <div class="resource-category">
                    <h3>EXAMES DEMANDADOS</h3>
                    <div class="resource-list">
                      <span *ngFor="let exame of resourceGroups.exames; let last = last" class="resource-item">
                        {{ exame.description }}{{ !last ? ';' : '' }}
                      </span>
                    </div>
                  </div>
                </ng-container>

                <!-- Seção de Terapias -->
                <ng-container *ngIf="resourceGroups.terapias.length > 0">
                  <div class="resource-category">
                    <h3>TERAPIAS DEMANDADAS</h3>
                    <div class="resource-list">
                      <span *ngFor="let terapia of resourceGroups.terapias; let last = last" class="resource-item">
                        {{ terapia.description }}{{ !last ? ';' : '' }}
                      </span>
                    </div>
                  </div>
                </ng-container>

              </ng-container>
            </div>

            <br />

            <div class="field-row">
              <span>Data da criação:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ resourceDemand.creationDate | date:'dd/MM/yyyy - hh:mm' }}</strong>
            </div>

            <div class="field-row">
              <span>Endereço:</span>
              <span class="field-dots"></span>
              <strong class="field-value">
                @if(resourceDemand.address?.street) {
                {{ resourceDemand.address?.street }}, {{ resourceDemand.address?.number }} -
                {{ resourceDemand.address?.city }}/{{ resourceDemand.address?.state }}}
              </strong>
            </div>

            <div>
              Disponibilidade:
              <app-availability [availabilityShow]="resourceDemand.availability"></app-availability>
            </div>

            <div class="footerButtons">

              <button mat-flat-button *ngIf="!resourceDemand.publicationDate" (click)="publish(resourceDemand.id!)">
                Publicar
                <mat-icon>rocket_launch</mat-icon>
              </button>

              <button mat-button [routerLink]="['resourceDemandForm', resourceDemand.id]">
                Alterar
                <mat-icon>published_with_changes</mat-icon>
              </button>

              <button mat-button (click)="deleteResourceDemand(resourceDemand.id!)">
                Excluir
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-panel-description>
        </mat-expansion-panel>
      </mat-accordion>

      <button mat-button [routerLink]="['resourceDemandForm']">
        Criar nova demanda de exames e terapias
        <mat-icon>edit_document</mat-icon>
      </button>
    </div>
  </ng-container>
</div>
}